import cable, { registerSharedCableCallbacks } from '@onpace/onspace-core/components/cable'
import translation from '@onpace/onspace-core/components/translations'

import OnspaceToast from '@onpace/onspace-core/elements/toast'

if (cable) {
  let offlineToast
  setTimeout(() => {
    offlineToast = new OnspaceToast({
      icon: 'onspace/icon_warning',
      text: translation('onspace.cms.interactions.connection.offline'),
      color: 'red'
    })
    window.offlineToast = offlineToast
  })

  registerSharedCableCallbacks({
    opened: () => offlineToast?.hide(),
    errored: () => offlineToast?.show()
  })
  cable.connect()
}
